import React, { useState, Fragment } from 'react';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useGetCreditCardsPagedQuery } from '../../../../services/creditCards';
import CreditCardsModal from '../../../../components/editCreditCardsModal';
import editIcon from '../../../../img/pencil-icon.svg';

import AdminDecryptCreditCardPopover from '../../../../components/creditCards/AdminDecryptCreditCardPopover';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
};

export default function CreditCardList({ isDeleted = false, active = true, assignedUserId, search = "" }) {
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [creditCardOnEditing, setCreditCardOnEditing] = useState(null);

  const { data: creditCards, error, isLoading, isFetching, refetch: refetchCCPaged } = useGetCreditCardsPagedQuery({
    pageNumber,
    pageSize,
    isDeleted,
    active,
    assignedUserId,
    search
  });

  const columns = [
    { field: 'id', hide: true, flex: 0.5 },
    { field: 'nameOnCard', headerName: 'NAME ON CARD', flex: 1 },
    { field: 'cardTypeName', headerName: "CARD TYPE NAME", flex: 1 },
    { field: 'last4Digits', headerName: 'LAST 4 DIGITS', flex: 1 },
    { field: 'expirationDate', headerName: 'EXPIRATION DATE', valueGetter: (params) => `${params.row.expirMonth || ''}/${params.row.expirYear || ''}`, flex: 1 },
    { field: 'assignedUserName', headerName: 'ASSIGNED USER', flex: 1 },
    {
      headerName: '', field: 'edit', flex: 0, renderCell: (params) => (
        <>
        <AdminDecryptCreditCardPopover creditCardId={params.row.id} />
        <Button onClick={() => setCreditCardOnEditing(params.row)} sx={{paddingLeft: 0}}>
          <img src={editIcon} alt='edit icon' height="18px" width="18px" />Edit
        </Button>
        </>
      ),
    },
  ];

  const handlePaginationChange = (params) => {
    const { page, pageSize } = params;
    setPageNumber(page + 1);
    setPageSize(pageSize);
  };

  if (error) return <p>Error fetching credit cards</p>;

  return (
    <Fragment>
      <div style={{ height: '100%', width: '100%' }}>
        <DataGridPremium
          pagination
          paginationMode="server"
          rows={creditCards?.items || []}
          columns={columns}
          rowCount={creditCards?.totalCount}
          page={pageNumber - 1}
          pageSize={pageSize}
          onPaginationModelChange={handlePaginationChange}
          loading={isLoading || isFetching}
        />
      </div>

      {creditCardOnEditing && (
        <Modal open={true} onClose={() => setCreditCardOnEditing(null)}>
          <Box sx={style}>
            <CreditCardsModal
              creditCard={creditCardOnEditing}
              setEditing={setCreditCardOnEditing}
              onSubmit={refetchCCPaged}
            />
          </Box>
        </Modal>
      )}
    </Fragment>
  );
}
